import { useTranslation } from 'react-i18next';
import type { IPartyCalendarUpcomingProps } from './IPartyCalendarUpcomingProps';
import { partyColors } from './partyColors';
import { dayLabel, weekdayLabel } from './partyDates';
import { eventLabel } from './partyEventText';

/**
 * «Найближчі події» (прототип v4 pcUp): картка з заголовком 11px великими літерами і кнопками подій від сьогодні — плитка дати в кольорах
 * типу («26 жовт.» і день тижня), назва запису й тип; без подій — «Найближчих подій немає.».
 */
export function PartyCalendarUpcoming({ events, lang, onOpen }: IPartyCalendarUpcomingProps) {
  const { t } = useTranslation();
  return (
    <aside className="pcal__aside" aria-label={t('modBody.pcal.upcoming')}>
      <div className="pcal__aside-title">{t('modBody.pcal.upcoming')}</div>
      {!events.length && <span className="pcal__none">{t('modBody.pcal.none')}</span>}
      {events.map((e) => {
        const c = partyColors(e.type.hue);
        return (
          <button key={`${e.type.key}:${e.record.id}`} type="button" className="pcal__up" onClick={() => onOpen(e)}>
            <span className="pcal__up-date" style={{ background: c.bg, color: c.fg }}>
              <strong>{dayLabel(e.date, lang)}</strong>
              <span>{weekdayLabel(e.date, lang)}</span>
            </span>
            <span className="pcal__up-text">
              <strong>{eventLabel(e)}</strong>
              <span>{e.type.label}</span>
            </span>
          </button>
        );
      })}
    </aside>
  );
}
